import { Trans } from 'react-i18next';

import { VisitMedicalImaging } from '@dreryk/egabinet-visit-frontend-api';

import { dateFormatter, hourMinuteFormatter } from '@dreryk/react-common';
import { appendTestableComponentAttributes, StrongText, StyledFlex } from '@dreryk/react-components';

import { visitHistoryTranslationKeys } from '../translations';

import { VisitHistoryMedicalImagingAttachment } from './VisitHistoryMedicalImagingAttachment';
import { VisitHistoryMedicalImagingAttachmentLoader } from './VisitHistoryMedicalImagingAttachment.loader';
import { StyledVisitHistoryText } from './VisitHistoryText.styled';

type VisitMedicalImagingItemProps = {
   readonly visitMedicalImaging: VisitMedicalImaging;
};

export const VisitHistoryMedicalImagingItem = (props: VisitMedicalImagingItemProps): JSX.Element | null => {
   return (
      <StyledFlex
         direction={'column'}
         gap={4}
         {...appendTestableComponentAttributes(
            'VisitHistoryMedicalImagingItem',
            props.visitMedicalImaging.medicalInformationId
         )}
      >
         <StrongText testId={'icd9CodeAndName'}>
            {`${props.visitMedicalImaging.icd9.getCode().toString()} - ${props.visitMedicalImaging.icd9.getName()}`}
         </StrongText>

         <div>
            <StyledVisitHistoryText testId={'examinationDate'}>
               <Trans
                  i18nKey={visitHistoryTranslationKeys.medicalImagingExaminationDate}
                  values={{
                     date: dateFormatter(props.visitMedicalImaging.examinationDate),
                     time: hourMinuteFormatter(props.visitMedicalImaging.examinationDate),
                  }}
               />
            </StyledVisitHistoryText>

            <div>
               <StyledVisitHistoryText testId={'description'}>
                  <Trans
                     i18nKey={visitHistoryTranslationKeys.medicalImagingDescription}
                     values={{
                        description: props.visitMedicalImaging.description.trim(),
                     }}
                  />
               </StyledVisitHistoryText>
            </div>
         </div>

         <VisitHistoryMedicalImagingAttachmentLoader
            visitMedicalInformationId={props.visitMedicalImaging.medicalInformationId}
         >
            {({ medicalInformationAttachments }) => (
               <VisitHistoryMedicalImagingAttachment medicalInformationAttachments={medicalInformationAttachments} />
            )}
         </VisitHistoryMedicalImagingAttachmentLoader>
      </StyledFlex>
   );
};
